import { render, staticRenderFns } from "./category-card.vue?vue&type=template&id=fd420de2"
import script from "./category-card.vue?vue&type=script&lang=ts"
export * from "./category-card.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiLink: require('/vercel/path0/components/ui/link.vue').default})
